import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Ech0134ModuleService {
  private deleteActionSubject = new Subject();
  deleteActionSubject$ = this.deleteActionSubject.asObservable();

  constructor() {}

  onDelete() {
    this.deleteActionSubject.next(null);
  }
}
